import createDebug from 'debug';
import { useEffect } from 'react';

const debug = createDebug('mnd:hotjar:debug');

const useHotjarTrigger = (trigger: string, doNotExecute = false) => {
  const { hj } = window;

  useEffect(() => {
    if (!doNotExecute && typeof hj === 'function') {
      hj('trigger', trigger);
      debug(`trigger: ${trigger}`);
    }
  }, [trigger, hj, doNotExecute]);
};

export default useHotjarTrigger;
